import React from 'react';
const IconActionBookmarkFill = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20 22.73V2H4V22.73L12 18.11L20 22.73Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconActionBookmarkFill;